var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgEnterInheritedCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 26.092C21.2467 26.092 25.5 21.8387 25.5 16.592C25.5 11.3453 21.2467 7.09204 16 7.09204C10.7533 7.09204 6.5 11.3453 6.5 16.592C6.5 21.8387 10.7533 26.092 16 26.092ZM16 27.092C21.799 27.092 26.5 22.391 26.5 16.592C26.5 10.7931 21.799 6.09204 16 6.09204C10.201 6.09204 5.5 10.7931 5.5 16.592C5.5 22.391 10.201 27.092 16 27.092Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9895 12.632C12.9895 12.3559 12.7657 12.132 12.4895 12.132C12.2134 12.132 11.9895 12.3559 11.9895 12.632V18.3579H20.3223L18.4817 20.1985C18.2864 20.3938 18.2864 20.7103 18.4817 20.9056C18.6769 21.1009 18.9935 21.1009 19.1888 20.9056L22.2366 17.8578L19.1888 14.81C18.9935 14.6147 18.677 14.6147 18.4817 14.81C18.2864 15.0053 18.2864 15.3218 18.4817 15.5171L20.3225 17.3579H12.9895V12.632Z"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgEnterInheritedCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/enter-inherited-circle.f551a3ab5b5e1e314bf596b4c656f14a.svg";